import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { useMemo, useRef } from "react";
import { isMobile } from "react-device-detect";

// Texture - module scope, bir marta yaratiladi (32x32)
let circleTexture = null;
const getCircleTexture = () => {
  if (circleTexture) return circleTexture;

  const canvas = document.createElement('canvas');
  canvas.width = 32;
  canvas.height = 32;
  const ctx = canvas.getContext('2d');

  const gradient = ctx.createRadialGradient(16, 16, 0, 16, 16, 16);
  gradient.addColorStop(0, 'rgba(255, 255, 255, 1)');
  gradient.addColorStop(0.3, 'rgba(255, 255, 255, 0.8)');
  gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');

  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, 32, 32);

  circleTexture = new THREE.CanvasTexture(canvas);
  return circleTexture;
};

export default function FlyingStars({ count = 150 }) {
  const pointsRef = useRef();
  const frameCount = useRef(0);

  // Desktop va Mobile: bir xil 150 ta (quality uchun)
  const actualCount = count;

  const texture = useMemo(() => getCircleTexture(), []);

  const { positions, speeds } = useMemo(() => {
    const pos = new Float32Array(actualCount * 3);
    const spd = new Float32Array(actualCount);

    for (let i = 0; i < actualCount; i++) {
      pos[i * 3 + 0] = (Math.random() - 0.5) * 100;
      pos[i * 3 + 1] = (Math.random() - 0.5) * 60;
      pos[i * 3 + 2] = Math.random() * -200;
      spd[i] = 0.4 + Math.random() * 0.3; // Random speed 0.4-0.7 (tezroq)
    }

    return { positions: pos, speeds: spd };
  }, [actualCount]);

  // Desktop va Mobile: har 2-frame (~30fps) - bir xil quality
  const frameSkip = 2;

  useFrame(() => {
    if (!pointsRef.current) return;

    frameCount.current++;
    if (frameCount.current % frameSkip !== 0) return;

    const posAttr = pointsRef.current.geometry.attributes.position;
    const arr = posAttr.array;

    for (let i = 0; i < actualCount; i++) {
      const idx = i * 3 + 2;
      arr[idx] += speeds[i];

      if (arr[idx] > 5) {
        arr[idx] = -200 + Math.random() * 10;
        arr[i * 3 + 0] = (Math.random() - 0.5) * 100;
        arr[i * 3 + 1] = (Math.random() - 0.5) * 60;
      }
    }

    posAttr.needsUpdate = true;
  });

  return (
    <points ref={pointsRef} frustumCulled={false}>
      <bufferGeometry>
        <bufferAttribute
          attach="attributes-position"
          array={positions}
          count={actualCount}
          itemSize={3}
        />
      </bufferGeometry>
      <pointsMaterial
        size={0.25}
        color="white"
        sizeAttenuation
        opacity={0.8}
        transparent
        map={texture}
        alphaMap={texture}
        depthWrite={false}
        blending={THREE.AdditiveBlending}
      />
    </points>
  );
}
